<template>
	<!--<van-nav-bar-->
	<!--	class="layout-header"-->
	<!--	:fixed="true"-->
	<!--	:left-arrow="!route.meta.showTab"-->
	<!--	:placeholder="true"-->
	<!--	v-if="!route.meta.hideTitle && !isWeChat()"-->
	<!--	:title="route.meta.title as string"-->
	<!--	@click-left="onClickLeft"-->
	<!--/>-->
	<div class="layout-content">
		<router-view v-slot="{ Component }">
			<keep-alive>
				<component :is="Component" v-if="$route.meta.keepAlive" :key="$route.name"></component>
			</keep-alive>
			<component :is="Component" v-if="!$route.meta.keepAlive" :key="$route.name"></component>
			<!-- <keep-alive :include="keepAliveRuter">
				<component :is="Component" :key="$route.name"></component>
			</keep-alive> -->
		</router-view>

		<!-- <keep-alive v-if="route.meta.keepAlive">
			<div>
				<router-view ></router-view>
			</div>
		</keep-alive>
		<router-view v-else></router-view> -->
	</div>
	<div class="layout-footer" v-if="route.meta.showTab">
		<van-tabbar v-model="activeRoute" active-color="#BD3A36" inactive-color="#6D6D6D">
			<van-tabbar-item name="Home" replace to="/layout/home">
				<template #icon="props">
					<img :src="props.active ? homeActive : home" />
				</template>
				<span>首页</span>
			</van-tabbar-item>
			<template v-if="isTeacher">
				<van-tabbar-item name="Task" :badge="todoTaskNum" replace to="/layout/task">
					<template #icon="props">
						<img :src="props.active ? taskActive : task" />
					</template>
					<span>任务</span>
				</van-tabbar-item>
				<van-tabbar-item name="Service" replace to="/layout/service">
					<template #icon="props">
						<img :src="props.active ? serviceActive : service" />
					</template>
					<span>办事大厅</span>
				</van-tabbar-item>
				<van-tabbar-item name="Information" replace to="/layout/information">
					<template #icon="props">
						<img :src="props.active ? messageActive : message" />
					</template>
					<span>资讯</span>
				</van-tabbar-item>
			</template>
			<template v-else>
				<van-tabbar-item name="Service" replace to="/layout/service">
					<template #icon="props">
						<img :src="props.active ? serviceActive : service" />
					</template>
					<span>办事大厅</span>
				</van-tabbar-item>
				<van-tabbar-item name="Information" replace to="/layout/information">
					<template #icon="props">
						<img :src="props.active ? messageActive : message" />
					</template>
					<span>资讯</span>
				</van-tabbar-item>
				<van-tabbar-item name="Task" :badge="todoTaskNum" replace to="/layout/task">
					<template #icon="props">
						<img :src="props.active ? taskActive : task" />
					</template>
					<span>任务</span>
				</van-tabbar-item>
			</template>
			<!--<van-tabbar-item-->
			<!--  name="Message"-->
			<!--  replace-->
			<!--  to="/layout/message"-->
			<!--  :icon="route.name === 'Message' ? messageActive : message"-->
			<!--&gt;消息-->
			<!--</van-tabbar-item>-->
			<van-tabbar-item name="Center" replace to="/layout/center" icon="manager-o">
				<template #icon="props">
					<van-icon v-if="props.active" name="manager" />
					<van-icon v-else name="manager-o" />
				</template>
				我的
			</van-tabbar-item>
		</van-tabbar>
		<More ref="moreRef" />
	</div>
</template>
<script setup lang="ts">
// import { useRoute } from 'vue-router'
import { ITabList } from '@/components/TabBar.vue'
import { reactive, watch, ref } from 'vue'
import { isWeChat } from '@/utils'
import home from '@/assets/img/tabbar/home.png'
import homeActive from '@/assets/img/tabbar/homeActive.png'
import task from '@/assets/img/tabbar/task.png'
import taskActive from '@/assets/img/tabbar/taskActive.png'
import message from '@/assets/img/tabbar/message.png'
import messageActive from '@/assets/img/tabbar/messageActive.png'
import service from '@/assets/img/tabbar/service.png'
import serviceActive from '@/assets/img/tabbar/serviceActive.png'
import more from '@/assets/img/tabbar/more.png'
import bg from '@/assets/img/tabbar/bgActive.png'
import More from '@/views/layouts/More.vue'
import { useAuthStore } from '@/store/auth'
import { getTodoTaskData } from '@/api'

// 测试husky
const route = useRoute()
const router = useRouter()
const moreRef = ref()
const todoTaskNum = ref(0)
const userStore = useAuthStore()

const activeRoute = ref(route.name as string)
const isTeacher = computed(() => {
	if (['BKS', 'YJS'].includes(userStore.userInfo.F_QuickQuery)) {
		return false
	}
	if (['JZG'].includes(userStore.userInfo.F_QuickQuery)) {
		return true
	}
	return false
})

// watch(activeRoute, (v) => {
// 	console.log('tab value v-model:', v)
// })
// const handleChange = (v: number) => {
// 	console.log('tab value @change:', v)
// }
watch(route, (v) => {
	activeRoute.value = v.name as string
	getTodoTaskNum()
})
const onClickLeft = () => {
	router.back()
}

const showMore = () => {
	moreRef.value.show()
}

const getTodoTaskNum = async () => {
	try {
		const data = {
			pageNumber: 1,
			pageSize: 100,
			ASSIGN_ID: userStore.userInfo.F_UserId
		}
		const res = await getTodoTaskData(data)
		const resData = res.data || []
		todoTaskNum.value = resData.length >= 100 ? '99+' : resData.length
	} catch (e) {
		console.log(e)
	}
}

onMounted(() => {
	// getTodoTaskNum()
})
</script>
<style lang="scss" scoped>
.layout-tabbar {
	width: 100%;
	height: 100%;
}
.layout-header {
	:deep(.van-nav-bar) {
		z-index: 9999;
	}
}
.activeTabBarBg {
	background-image: url('~@/assets/img/tabbar/bgActive.png');
	width: 40px;
	height: 55px;
	display: flex;
	flex-direction: column;
	font-size: 10px;
	> img {
		width: 24px;
		height: 24px;
		margin-bottom: 2px;
	}
}
</style>
